import { render, staticRenderFns } from "./expDocsMX.vue?vue&type=template&id=320e7e8c"
import script from "./expDocsMX.vue?vue&type=script&lang=js"
export * from "./expDocsMX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports